<template>
  <div class="catalogue">
    <div class="header-tool">
      <div class="header-tool-info">
        <div style="display: flex; align-items: center">
          <Breadcrumb>
            <BreadcrumbItem>参展</BreadcrumbItem>
            <BreadcrumbItem>证件申请</BreadcrumbItem>
          </Breadcrumb>
          <!-- 2026-08-20 修改：证件申请截止时间改为 10月20日中午12点（原代码注释保留） -->
          <!-- <p v-if="exhibition.id == 'ec6c5271-2bdd-48c7-9984-26ef50d21f4f'" style="margin-left: 20px; font-size: 20px; color: red">
            2026年7月17日 中午12:00点截止
          </p>
          <p v-else style="margin-left: 20px; font-size: 20px; color: red">
          展商证件申请已截止
          </p> -->
          <p v-if="exhibition.id == 'ec6c5271-2bdd-48c7-9984-26ef50d21f4f'" style="margin-left: 20px; font-size: 20px; color: red">
            10月20日中午12点截止
          </p>
          <p v-else style="margin-left: 20px; font-size: 20px; color: red">
            10月20日中午12点截止
          </p>
        </div>
        <!-- 截止时间:2024年9月16日 -->

        <div class="header-tool-title" v-if="exhibition.name">
          {{ exhibition.name }}
        </div>
      </div>
      <!-- <div>
        由于疫情原因，展馆实行展商实名认证，且限制人流量
        </br>
        展商证发放规则：3张/9平米    进场需携带身份证原件
        </br>
        请根据企业展位面积计算可申请展商证数量，如到场人员超过可申请数量
        </br>
        <a href="https://www.larspring.cn/front/exhibitionregister/toExhibitionPage/23d7e4b773614d1780bc6670ade88cf2?sid=f22da08f462d405f8a309ae0e6d26d8c" target="_blank">请点击此处进行观众预登记注册</a>

      </div> -->
      <!-- <div style="display: flex">
        <div class="header-tool-box" @click="addExcel()">
          <div class="htb-item">
            <span class="htb-add">+</span>
            <span>批量导入</span>
          </div>
        </div>


        <div class="header-tool-box">
          <div class="htb-item" @click="add()">
            <span class="htb-add">+</span>
            <span>添加证件</span>
          </div>
        </div>
      </div> -->
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <!-- <TabPane label="已确认" name="1">
          <exhibitionCertYes
            :addShow="addShow"
            @closeModal=" addShow = false; showTabs='2'"
            v-if="String(showTabs) === '1'"
            ref="exhibitionCertYes"
          ></exhibitionCertYes>
        </TabPane>
        <TabPane label="未审核" name="2">
          <exhibitionCertNo
            ref="exhibitionCertNo"
            :addShow="addShow"
            @closeModal=" addShow = false; $refs.exhibitionCertNo.init();"
            v-if="String(showTabs) === '2'"
          ></exhibitionCertNo>
        </TabPane> -->
        <TabPane label="展商证" name="1">
          <excard v-if="String(showTabs) === '1'"></excard>
        </TabPane>
        <TabPane label="特邀嘉宾" name="2" v-if="exhibition.applyForSpecifications!=1">
          <!-- <exhibitionCertNo
            ref="exhibitionCertNo"
            :addShow="addShow"
            @closeModal=" addShow = false; $refs.exhibitionCertNo.init();"
            v-if="String(showTabs) === '2'"
          ></exhibitionCertNo> -->
          <exspecial v-if="String(showTabs) === '2'"></exspecial>
        </TabPane>
        <TabPane label="海外/港澳台认证" name="3">
          <exhibitionCertEn v-if="String(showTabs) === '3'"></exhibitionCertEn>
        </TabPane>
        <TabPane label="VIP" name="4" v-if="exhibition.applyForSpecifications!=1">
          <excardVip v-if="String(showTabs) === '4'"></excardVip>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
import exhibitionCertYes from "./components/exhibition-cert-yes";
import exhibitionCertNo from "./components/exhibition-cert-no";

import excard from "./components/exhibition-card";
import excardVip from "./components/exhibition-card-vip";
import exspecial from "./components/exhibition-special-guests";
import exhibitionCertEn from "./components/exhibition-cret-En";
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "exhibition-info-carApply",
  data() {
    return {
      addShow: false,
      showTabs: "1",
      modal1: false,
      disabled: true, //是否禁用上传文件按钮
    };
  },
  components: {
    exhibitionCertYes,
    exhibitionCertNo,
    excard,
    excardVip,
    exspecial,
    exhibitionCertEn,
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition",
      uploadUrl: "getUploadUrl2",
      
    }),
  },
async  created() {
    document.title = "中国国际医疗器械博览会 - 展商证申请";
      let ex = await this.getExhibitionById(this.exhibition.id);
      this.setExhibition(ex);
  },
  methods: {
        ...mapMutations({
      setExhibition: "loginModule/setExhibition",
    }),
        ...mapActions({

      getExhibitionById: "exhibitionModule/getExhibitionById",
    }),
    switchBrand() {},
    add() {
      if (this.showTabs == "1") {
        this.addShow = true;
        this.$refs["exhibitionCertYes"].addCert();
      } else {
        this.addShow = true;
        this.$refs["exhibitionCertNo"].addCert();
      }
    },

    addExcel() {
      if (this.showTabs == "1") {
        this.$refs["exhibitionCertYes"].addCert1();
      } else {
        this.$refs["exhibitionCertNo"].addCert1();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.catalogue {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
  /deep/ {
    .ivu-tabs-tab {
      font-size: 24px;
      font-weight: bold;
    }
  }
}
</style> 
